@if (value().title || value().timestamp) {
<div class="w-full flex flex-row justify-between mb-3">
  <h3>{{ value().title }}</h3>
  <span class="text-light text-xs">
    {{ value().timestamp | format : 'DATE_TIME.SECONDS' }}
  </span>
</div>
}
